import { Injectable } from '@angular/core'
import { CanActivate, CanLoad, Route } from '@angular/router'
import { select, Store } from '@ngrx/store'
import { IsDataLoaded } from '@tokeet/tv3-platform'
import { Observable, of } from 'rxjs'
import { catchError, map, switchMapTo, take, tap } from 'rxjs/operators'
import { LoadEntityTags } from './actions'
import { isEntityTagsLoaded } from './selectors'

@Injectable()
export class EntityTagsGuard implements CanActivate, CanLoad, IsDataLoaded {
  constructor(private store: Store<any>) {}

  canActivate(): Observable<boolean> {
    return this.isDataLoaded().pipe(
      switchMapTo(of(true)),
      catchError(() => of(false))
    )
  }

  isDataLoaded(): Observable<boolean> {
    return this.store.pipe(
      select(isEntityTagsLoaded),
      tap((isLoaded) => {
        if (!isLoaded) this.store.dispatch(LoadEntityTags())
      }),
      map(() => true),
      take(1)
    )
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate()
  }
}
